import { defineComponent } from 'vue'

export const EmptyPage = defineComponent({
  setup() {
    return null
  },
})
